export class OptionsTransportDteEmitido {
   facturaAcompanaTraslado: boolean = false;
   destinoDistintoReceptor: boolean = false;
   tipoDespacho?: number;
   rutTransporte: number;
   patente: string;
   patenteCarro?: string;
   rutChofer: number;
   nombreChofer: string;
   dvChofer: string;
   dvTransporte: string;
   dirDest?: string;
   cmnaDest?: string;
   fechaSalida?: string;
   horaSalida?: string;
   fechaLlegada?: string;

   comunaOrigenId: number;
   mnzRolOrigen?: number;
   prdRolOrigen?: number; 
   codPlanConaf?: string; 
   latitudOrigenMadera?: string; 
   longitudOrigenMadera?: string;
}
